import { render, staticRenderFns } from "./VirtualScrollContainer.vue?vue&type=template&id=3bbf820e&scoped=true"
import script from "./VirtualScrollContainer.vue?vue&type=script&lang=ts"
export * from "./VirtualScrollContainer.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScrollContainer.vue?vue&type=style&index=0&id=3bbf820e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf820e",
  null
  
)

export default component.exports